import React from "react";
import styles from "./TermsConditions.module.css";

const TermsConditions = () => {
  return (
    <div className={styles.container}>   
    <section className={styles.termsConditionsSection}>
      <h1>
        Terms and Conditions
      </h1>

      <p>
        <strong>Effective Date: </strong>August 15, 2025
      </p>

      <p>
        Welcome to the Beyond Baptism website (“Site”). This Site is operated by <strong>Beyond Baptism Charitable Fund</strong>. By accessing or using our Site, you agree to comply with and be bound by the following terms and conditions (“Terms”). If you do not agree with these Terms, please do not use this Site.
      </p>

      <div>

      <div>
        <h4>
            Use of the Site
        </h4>
        <p>
            The Site is provided for your personal, non-commercial use. You agree not to misuse the Site or engage in activities that may harm, disrupt, or interfere with the Site or its users.
        </p>
      </div>

      <div>
        <h4>
            Intellectual Property
        </h4>
        <p>
            All content on this Site, including but not limited to text, graphics, logos, and videos, is the property of Beyond Baptism unless otherwise stated. You may not reproduce, distribute, or modify any content without written permission.
        </p>
      </div>

      <div>
        <h4>
            Privacy
        </h4>
        <p>
            Your use of the Site is also governed by our Privacy Policy, which explains how we collect, use, and protect your information.
        </p>
      </div>

      <div>
        <h4>
            Links to Other Sites
        </h4>
        <p>
            Our Site may include links to external websites. Beyond Baptism is not responsible for the content, accuracy, or practices of these third-party sites.
        </p>
      </div>

      <div>
        <h4>
            Disclaimer of Warranties
        </h4>
        <p>
            The Site and its content are provided “as is” without warranties of any kind, either express or implied. We do not guarantee that the Site will always be available, secure, or error-free.
        </p>
      </div>

      <div>
        <h4>
            Limitation of Liability
        </h4>
        <p>
            Beyond Baptism, its staff, volunteers, and partners are not liable for any damages arising from your use of the Site, including direct, indirect, incidental, or consequential damages.
        </p>
      </div>

      <div>
        <h4>
            Indemnification
        </h4>
        <p>
            You agree to protect and not hold Beyond Baptism, along with its staff, volunteers, and partners, responsible for any claims, damages, costs, or expenses that result from your use of the Site or from violating these Terms.
        </p>
      </div>

      <div>
        <h4>
            Termination
        </h4>
        <p>
            We have the right to suspend or end your access to the Site at any time, without notice, if we believe you have broken these Terms or acted in a way that could harm others.
        </p>
      </div>

      <div>
        <h4>
            Changes to Terms
        </h4>
        <p>
            We may update these Terms and Conditions at any time. Continued use of the Site after changes are posted constitutes your acceptance of the updated Terms.
        </p>
      </div>

      <div>
        <h4>
            Governing Law
        </h4>
        <p>
            These Terms and Conditions are governed by the laws of the State of New Jersey, without regard to its conflict of law principles.
        </p>
      </div>

      <div>
        <h4>
            Contact Us
        </h4>
        <p>
            If you have any questions about these Terms and Conditions, please contact us:<br />
            <strong>Beyond Baptism Ministry</strong><br />
            Email: <a href="mailto:admin@beyondbaptism.com"><strong>admin@beyondbaptism.com</strong></a><br />
            Mailing Address: <strong>169 Holmes Street, Belleville, NJ 07109</strong>
        </p>
      </div>

      </div>

    </section>
    </div>
  );
};

export default TermsConditions;
